import React from "react";
import { Marker, Polygon, Polyline, Rectangle, Circle } from "react-google-maps";
import {getBasicAssetMarker, MARKER_HEIGHT, MARKER_WIDTH} from "../utilities";

const getPolygonElement = ({
                               asset,
                               polygon,
                               index,
                               onMarkerClick,
                               markerPolygon,
                               getOpacity,
                               colors,
                               isReportSelectMode,
                               reportAssets,
                               addAssetToReport
                           }) => {
    const defaultColor = polygon.color ? colors[polygon.color] : colors[parseInt(asset.plant_color)];
    const highlightedColor = colors[51];
    const color = isReportSelectMode && reportAssets.includes(asset.id) ? highlightedColor : defaultColor;
    const opacity = getOpacity(asset);

    const handleClick = () => {
        if (isReportSelectMode) {
            addAssetToReport(asset.id);
        } else {
            onMarkerClick(asset.id);
        }
    };

    switch (polygon.type_polygon) {
        case "circle":
            return (
                <>
                    <Circle
                        key={index}
                        onClick={handleClick}
                        defaultCenter={polygon.polygon_points[0]}
                        radius={polygon.radius}
                        options={{ fillOpacity: opacity, strokeColor: color, fillColor: color }}
                        editable={false}
                    />
                    {markerPolygon(asset)}
                </>
            );
        case "polyLine":
            return (
                <>
                    <Polyline
                        key={index}
                        onClick={handleClick}
                        path={polygon.polygon_points}
                        options={{ strokeOpacity: opacity, strokeColor: color, fillColor: color }}
                        editable={false}
                    />
                    {markerPolygon(asset)}
                </>
            );
        case "rectangle":
            if (
                polygon.polygon_points.length >= 4 &&
                polygon.polygon_points[0] &&
                polygon.polygon_points[1] &&
                polygon.polygon_points[3]
            ) {
                return (
                    <>
                        <Rectangle
                            key={index}
                            onClick={handleClick}
                            bounds={{
                                north: polygon.polygon_points[0].lat,
                                south: polygon.polygon_points[3].lat,
                                east: polygon.polygon_points[1].lng,
                                west: polygon.polygon_points[0].lng
                            }}
                            options={{ fillOpacity: opacity, strokeColor: color, fillColor: color }}
                            editable={false}
                        />
                        {markerPolygon(asset)}
                    </>
                );
            }
            return null;
        default:
            return (
                <>
                    <Polygon
                        key={index}
                        onClick={handleClick}
                        path={polygon.polygon_points}
                        options={{ fillOpacity: opacity, strokeColor: color, fillColor: color }}
                        editable={false}
                    />
                    {markerPolygon(asset)}
                </>
            );
    }
};

const AssetMapPolygons = ({
                              assets,
                              onMarkerClick,
                              markerPolygon,
                              getMarkerIcon,
                              getOpacity,
                              colors,
                              isReportSelectMode,
                              reportAssets,
                              addAssetToReport,
                              spriteUrl,
                              markerOrigins,
                          }) => {
    return assets.map((asset, index) => {
        const polygon = asset.polygons.find(p => p.chosen);

        if (polygon && polygon.type_polygon !== "marker") {
            return getPolygonElement({
                asset,
                polygon,
                index,
                onMarkerClick,
                markerPolygon,
                getOpacity,
                colors,
                isReportSelectMode,
                reportAssets,
                addAssetToReport
            });
        }

        const highlighted = isReportSelectMode && reportAssets.includes(asset.id);

        const origin = markerOrigins?.[asset.id]?.origin;
        let icon;

        if (spriteUrl && origin && !highlighted) {
            icon = {
                url: spriteUrl,
                size: new google.maps.Size(MARKER_WIDTH, MARKER_HEIGHT),
                origin: new google.maps.Point(origin.x, origin.y),
                anchor: new google.maps.Point(MARKER_WIDTH / 2, MARKER_HEIGHT),
            };
        } else {
            icon = getMarkerIcon({ asset, highlighted, label: asset.label });
        }


        return (
            <Marker
                key={asset.id}
                position={{ lat: asset.latitude, lng: asset.longitude }}
                icon={icon}
                title={
                    asset.plant_name + (asset.plant_count > 1 ? ` [${asset.plant_count}]` : "")
                }
                onClick={() =>
                    isReportSelectMode
                        ? addAssetToReport(asset.id)
                        : onMarkerClick(asset.id)
                }
            />
        );
    });
};

export default AssetMapPolygons;